import React from 'react';
import PropTypes from 'prop-types';
import { SEOFooter as SEOFooter$1 } from '@zillow/zrs-cms';

var BlockSEOFooter = function BlockSEOFooter(_ref) {
  var index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var submenuItems = innerBlocks.map(function (block) {
    return {
      label: block.attrs.label,
      links: block.innerBlocks.map(function (link) {
        return {
          src: link.attrs.url,
          label: link.attrs.label,
          target: link.attrs.opensInNewTab ? '__blank' : ''
        };
      })
    };
  });
  return /*#__PURE__*/React.createElement(SEOFooter$1, {
    key: index,
    submenuItems: submenuItems
  });
};
BlockSEOFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number
} : {};
var SEOFooter = BlockSEOFooter;

export { SEOFooter as default };
